import PropTypes from 'prop-types'
import { Alert, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import LinkButtonTooltip from '../../../ui/components/LinkButtonTooltip'

import styles from './styles'

const propTypes = {
  loadingLastRate: PropTypes.bool,
  openLastRate: PropTypes.func,
}

const RatesView = ({ loadingLastRate, openLastRate }) => {
  const t = useTranslations()

  const handleOpenLastRateClick = date => e => {
    e.preventDefault()
    openLastRate(date)
  }

  return (
    <>
      <Alert severity="info" sx={styles.alert}>
        <Typography variant="h4" sx={styles.alertTitle}>
          {t('billing:subtitle')}
        </Typography>
        {/* <LinkButtonTooltip
          placementTooltip="right"
          text={t('billing:see-my-rate-2023')}
          tooltipText={t('billing:find-review-documentation-contract')}
          onClick={handleOpenLastRateClick('2023-12-31')}
        /> */}
        <LinkButtonTooltip
          placementTooltip="right"
          text={t('billing:see-my-rate-2024')}
          tooltipText={t('billing:find-review-documentation-contract')}
          onClick={handleOpenLastRateClick('2024-01-01')}
        />
      </Alert>
    </>
  )
}

RatesView.propTypes = propTypes

export default RatesView
